import axios from '../utils/axios';

export default function getPremiumJobsCount (adminId, params) {
    return axios.get(`/admin/${adminId}/get-premium-jobs-count`, { params });
}